import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import './styles/tailwind.css';
import App from './App';

// Get the root element
const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If the page was pre-rendered (Puppeteer + scripts/prerender.mjs marks
// document with data-prerendered="true" and the #root container will have
// hydratable content), use hydrateRoot to reuse the existing DOM. This
// dramatically improves LCP because the prerendered content stays painted
// instead of being replaced when React mounts. Otherwise (dev or non-
// prerendered routes) fall back to createRoot.
const isPrerendered =
  document.documentElement.dataset.prerendered === 'true' &&
  container.hasChildNodes();

if (isPrerendered) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}